import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const DeleteMediaResourcesSchema = z.object({
  ids: z
    .array(uuidValidator)
    .min(1, 'At least one media resource ID must be provided'),
});

export type IDeleteMediaResourcesDto = z.infer<
  typeof DeleteMediaResourcesSchema
>;
